import { format } from "date-fns";
import React from "react";

//components
import FilterChips, { Filter } from "../../../../../../../components/FilterChips/FilterChips";

import { AllFormsFilter, StatusSelectionOptions } from "../AllFormsFilters";

const convertFiltersToReadableList = (filters?: AllFormsFilter) => {
	const readableList: Filter[] = [];

	if (filters) {
		Object.keys(filters).forEach((filterKey) => {
			const filter = filters[filterKey];

			if (filterKey === "subject") {
				readableList.push({
					id: "subject",
					type: "single-employee",
					label: "Subject",
					value: { name: filter.name, id: filter.id },
				});
			}

			if (filterKey === "status" && Array.isArray(filter) && filter.length > 0) {
				const labels = filter
					.map((value) => StatusSelectionOptions.find((option) => option.value === value)?.label || value)
					.join(", ");
				readableList.push({
					id: "status",
					type: "string",
					label: "Status",
					value: labels,
				});
			}

			if (filterKey === "form") {
				readableList.push({
					id: "form",
					type: "string",
					label: "Form",
					value: filter.name,
				});
			}

			if (filterKey === "showOnlyExternalForms" && Array.isArray(filter) && filter.length > 0) {
				readableList.push({
					id: "showOnlyExternalForms",
					type: "string",
					label: "Form",
					value: "External",
				});
			}

			if (filterKey === "authors") {
				readableList.push({
					id: "authors",
					type: "multiple-employees",
					label: "Authors",
					value: filter.map((employee) => ({ name: employee.name, id: employee.id })),
				});
			}

			if (filterKey === "showOnlyFormsWithUnassignedAuthors" && Array.isArray(filter) && filter.length > 0) {
				readableList.push({
					id: "showOnlyFormsWithUnassignedAuthors",
					type: "string",
					label: "Author",
					value: "Unassigned",
				});
			}

			if (filterKey === "includeDeactivatedSubjects" && Array.isArray(filter) && filter.length > 0) {
				readableList.push({
					id: "includeDeactivatedSubjects",
					type: "string",
					label: "Subject",
					value: "Deactivated",
				});
			}

			if (filterKey === "signers") {
				readableList.push({
					id: "signers",
					type: "multiple-employees",
					label: "Signers",
					value: filter.map((employee) => ({ name: employee.name, id: employee.id })),
				});
			}

			if (filterKey === "authorsDueDateAfter") {
				readableList.push({
					id: "authorsDueDateAfter",
					type: "string",
					label: "Authors Due Date After",
					value: format(filter, "yyyy-MM-dd"),
				});
			}

			if (filterKey === "authorsDueDateBefore") {
				readableList.push({
					id: "authorsDueDateBefore",
					type: "string",
					label: "Authors Due Date Before",
					value: format(filter, "yyyy-MM-dd"),
				});
			}

			if (filterKey === "signersDueDateAfter") {
				readableList.push({
					id: "signersDueDateAfter",
					type: "string",
					label: "Signers Due Date After",
					value: format(filter, "yyyy-MM-dd"),
				});
			}

			if (filterKey === "signersDueDateBefore") {
				readableList.push({
					id: "signersDueDateBefore",
					type: "string",
					label: "Signers Due Date Before",
					value: format(filter, "yyyy-MM-dd"),
				});
			}

			if (filterKey === "completedDateAfter") {
				readableList.push({
					id: "completedDateAfter",
					type: "string",
					label: "Completed Date After",
					value: format(filter, "yyyy-MM-dd"),
				});
			}

			if (filterKey === "completedDateBefore") {
				readableList.push({
					id: "completedDateBefore",
					type: "string",
					label: "Completed Date Before",
					value: format(filter, "yyyy-MM-dd"),
				});
			}
		});
	}

	return readableList;
};

type AllFormsReadableFiltersListProps = {
	filters: AllFormsFilter;
	setFilters: (newFilters) => void;
};

const AllFormsReadableFiltersList = ({ filters, setFilters }: AllFormsReadableFiltersListProps) => {
	const convertedFilters = convertFiltersToReadableList(filters);

	if (convertedFilters.length === 0) {
		return null;
	}

	return (
		<div>
			<FilterChips
				filters={convertedFilters}
				label="Filters applied: "
				onDeleteFilter={(id) => {
					const currentFilters = { ...filters };
					delete currentFilters[id];

					setFilters({ ...currentFilters });
				}}
			/>
		</div>
	);
};

export default AllFormsReadableFiltersList;
